module.exports = __webpack_public_path__ + "staticfr/media/gif-dimen-fr.9028a16b.gif";